var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7106 11.6395C41.8604 11.6395 42.9187 11.1294 43.8863 10.168C44.0788 10.5057 44.173 10.8897 44.1583 11.2773C44.1414 11.7097 44.0495 12.1359 43.8863 12.5371L43.9474 12.627C45.7606 12.5371 46.8197 12.0278 47.8788 11.2177C48 11.9689 48 12.3025 48 13.2018C48 17.0439 44.5218 20.7308 39.9226 20.7308C35.3895 20.7308 31.8784 17.0709 31.8784 12.8413H31.3945C31.0919 13.6513 30.9708 14.5211 31.0919 15.6909C26.0412 17.7013 24.6804 20.9107 24.6804 24H21.6275C21.4664 22.3367 21.6201 20.6582 22.0808 19.0509C22.474 17.7013 23.2001 15.9608 24.5608 14.6111L24.1677 14.1909C22.3545 15.6313 22.0503 16.1708 20.4777 18.2106C19.1779 18.4811 18.0874 19.2307 16.2437 19.2307C15.0642 19.2307 13.8246 19.0509 11.8284 18.1206C12.4053 17.1306 12.796 16.2313 12.8867 14.5816H12.2816C11.0726 19.4711 6.29373 20.2804 4.23731 20.6409C2.42403 20.9409 1.78773 22.2906 1.78773 23.6101C1.78493 23.7407 1.79486 23.8713 1.8174 24H0.0906688C0.030124 23.5628 -0.000167948 23.122 7.00312e-07 22.6806C7.00312e-07 21.7209 0.0601694 20.7603 0.514314 19.9509C2.15121 17.2189 3.51117 16.1986 3.51117 14.101C3.51117 11.9411 1.90807 10.504 1.8174 10.4116C2.75536 10.2587 3.08835 9.35949 3.723 8.39974C5.11427 6.26942 7.4427 5.93987 8.65265 5.93987C9.8321 5.93987 10.5277 6.08955 11.7072 6.08955C17.1207 6.08955 19.8431 0 26.4359 0C30.6099 0 33.483 3.00024 33.9059 6.8669L33.9966 6.89721C34.5413 6.29721 35.4802 5.48702 36.5673 5.12727C36.5673 5.27772 36.5376 5.45431 36.5376 5.63746C36.5376 8.51911 37.3239 11.6395 40.7106 11.6395ZM12.2816 23.9976H9.52962C8.59248 23.1278 7.9875 21.8083 7.83584 21.0546C9.52961 20.3352 10.2862 19.7948 11.2234 18.8947L11.7682 19.3149C11.4241 19.9076 11.2465 20.5809 11.2539 21.2646C11.2539 21.9277 11.2539 22.3176 12.2816 23.9976ZM28.8254 23.9976H26.3453C26.3453 20.6981 27.3129 19.5283 28.7043 18.208L29.1278 18.5351C28.5509 19.7948 28.4924 20.6646 28.4924 21.505C28.4924 22.5882 28.6136 23.3075 28.8254 23.9976Z",
    fill: "url(#paint0_radial_17216_16529)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17216_16529",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(26.5651) scale(53.6657 42.9325)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F25E40"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.0bd717253ec5102e9e959e3e77b47d96.svg";
export { ForwardRef as ReactComponent };